import React from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import DaProtectNotice from '../DaProtectNotice';
import BetaBadge from '../../../BetaBadge';
import s from './HoverComponent.scss';
const HoverComponent = ({ svg, title, context, className, isNew = false, showDaProtect = false })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['container'], showDaProtect && s['da-protect-container'], isNew && s['new-container'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['svg']
    }, /*#__PURE__*/ React.createElement("img", {
        loading: "lazy",
        src: Url.staticCDNLink(`eclipse/popups/hover-component/${svg}`),
        alt: ""
    })), isNew && /*#__PURE__*/ React.createElement(BetaBadge, {
        badgeType: "new",
        variant: "medium"
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['title']
    }, title), /*#__PURE__*/ React.createElement("div", {
        className: s['context']
    }, context), showDaProtect && /*#__PURE__*/ React.createElement(DaProtectNotice, null)));
};
HoverComponent.displayName = 'HoverComponent';
export default HoverComponent;
